<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" >
  <div class="row mb-5">
    <div class="col-md-12">
      <form class="form" [formGroup]="formGroup" (ngSubmit)="onSave()" novalidate>
        <div class="row">
          <div class="col-sm-6 pull-right"><h4>My Profile</h4></div>
          <div class="col-sm-6 text-right pull-right">
            <button class="btn btn-outline-dark mr-1" type="button">{{ 'cancel' | translate }}</button>
            <button class="btn btn-admin-primary" [promiseBtn]="submitComplete" type="submit">{{ 'save' | translate }}</button>
          </div>
        </div>
        <!--
      <hr class="mb-4" />

      <h4 class="mb-3">Company Details</h4>
      -->
        <div class="media align-items-center mb-7">
          <div class="u-lg-avatar mr-3">
            <span *ngIf="!croppedImage" class="btn btn-lg btn-icon btn-dark rounded-circle mr-3">
              <span class="btn-icon__inner">{{ auth.user.firstName.substr(0, 1).toUpperCase() }}{{ auth.user.lastName.substr(0, 1).toUpperCase() }}</span>
            </span>
            <img *ngIf="croppedImage" class="img-fluid" [src]="croppedImage"  />
          </div>

          <div class="media-body">
            <button type="button" (click)="editImage(content)" class="btn btn-sm btn-admin-primary transition-3d-hover mb-1 mr-2 mb-sm-0">{{ 'upload-headshot' | translate }}</button>
            <button type="button" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">{{ 'delete' | translate }}</button>
          </div>
        </div>
        <div *ngIf="formGroup?.controls['email'].errors && formGroup?.controls['email'].errors.emailTaken" class="alert alert-danger">
          <h6>
            {{ 'email-taken' | translate }} <a href="mailto:{{ settings.brand.supportAddress }}">{{ settings.brand.supportAddress }}</a>
          </h6>
        </div>
        <div class="row">
          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'first-name' | translate }}</label>
            <input type="text" class="form-control" formControlName="firstName" />
            <div class="invalid-message">
              <div>{{ 'first-name-is-required' | translate }}</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="country">{{ 'last-name' | translate }}</label>
            <input type="text" class="form-control" formControlName="lastName" />
            <div class="invalid-message">
              <div>{{ 'last-name-is-required' | translate }}</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="country">{{ 'credentials' | translate }}</label>
            <input type="text" class="form-control" formControlName="credentials" />
            <div class="invalid-message">
              <div>{{ 'credentials-is-required' | translate }}</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'preferred-pronouns' | translate }} (Public) <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="pronouns" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'email' | translate }}</label>
            <input type="text" class="form-control" formControlName="email" />
            <div class="invalid-message">
              <div *ngIf="formGroup?.controls['email'].errors && formGroup?.controls['email'].errors.emailTaken">{{ 'email-taken-short' | translate }}</div>
              <div *ngIf="formGroup?.controls['email'].errors && formGroup?.controls['email'].errors.required">{{ 'email-is-required' | translate }}</div>
              <div *ngIf="formGroup?.controls['email'].errors && formGroup?.controls['email'].errors.email">{{ 'email-is-not-valid' | translate }}</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'alternate-email' | translate }} <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="alternateEmail" />
            <div class="invalid-message">
              <div>{{ 'email-is-not-valid' | translate }}</div>
            </div>
          </div>
          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'affiliation' | translate }} <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="affiliation" />
          </div>

          <div class="col-md-3 mb-5">
            <label for="firstName">{{ 'phone' | translate }} <span class="text-muted"></span></label>
            <input type="text" class="form-control" formControlName="phoneNumber" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="zip">{{ 'biography' | translate }}</label>
            <ckeditor [editor]="Editor" formControlName="biography" [config]="htmlEditorConfig" style="width: 100%"></ckeditor>

            <div class="invalid-message">
              <div>{{ 'biography-is-required' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- End My Network -->
      </form>
    </div>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ 'edit-image' | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-md-12 text-center">
        <label class="btn-bs-file btn btn-lg btn-primary">
          {{ 'choose-an-image' | translate }}
          <input type="file" (change)="fileChangeEvent($event)" />
        </label>

        <image-cropper [imageChangedEvent]="imageChangedEvent" [imageBase64]="initialCroppedImage" [maintainAspectRatio]="true" [onlyScaleDown]="true" [aspectRatio]="1 / 1" [resizeToWidth]="512" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (loadImageFailed)="loadImageFailed()"></image-cropper>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">{{ 'save' | translate }}</button>
    </div>
  </ng-template>
</div>
